import PaymentAside from "./PaymentAside";
import PaymentMain from "./PaymentMain";
import PaymentRoot from "./PaymentRoot";

const PaymentFormLayout = {
    Root: PaymentRoot,
    Aside: PaymentAside,
    Main: PaymentMain,
}

export default PaymentFormLayout;